module.exports = __webpack_public_path__ + "img/5.265cd0fc.jpg";